import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { linksOf } from "../../services/cpln";
import { Image } from "../../schema/types/image/entity";
import { FormItemDescription } from "../../components/antd/form/FormItemDescription";
import { ChevronDown, ChevronUp } from "react-feather";
import { SyntaxHighlight } from "../../components/syntaxHighlight/SyntaxHighlight";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { CopyButtonWithApproval } from "../domain/create/copyButtonWithApproval";

interface Props {
  image: Image;
}
export const Summary: React.FC<Props> = ({ image }) => {
  const [isManifestOpen, setIsManifestOpen] = React.useState(false);
  function toggleManifest() {
    setIsManifestOpen((val) => !val);
  }

  const selfLink = linksOf(image).self!;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <FormItem>
              <FormLabel>Image Link</FormLabel>
              <FormItemDescription>Self link of image to be used in containers.</FormItemDescription>
              <div className="flex items-center gap-2">
                <FormItemValue>{selfLink}</FormItemValue>
                <CopyButtonWithApproval value={selfLink} />
              </div>
            </FormItem>
            {Object.entries(image.tags || {}).filter(([_, value]) =>
              tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
            ).length > 0 ? (
              <TagLinksTable
                tableId="image-info-tag-links"
                tags={Object.entries(image.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
            <FormItem>
              <div className="flex mb-2">
                <button type={`button`} className="ngfocus color-link" onClick={toggleManifest}>
                  Manifest
                  {isManifestOpen ? (
                    <ChevronUp
                      data-testid="toggle-manifest"
                      className="inline-block"
                      size={16}
                      style={{ transform: "translateY(2px)" }}
                    />
                  ) : (
                    <ChevronDown
                      data-testid="toggle-manifest"
                      className="inline-block"
                      size={16}
                      style={{ transform: "translateY(2px)" }}
                    />
                  )}
                </button>
                {isManifestOpen ? (
                  <CopyButtonWithApproval className="ml-2" value={JSON.stringify(image.manifest, null, 2)} />
                ) : null}
              </div>
              {isManifestOpen ? (
                <SyntaxHighlight
                  code={JSON.stringify(image.manifest, null, 2)}
                  language="json"
                  showLineNumbers
                />
              ) : null}
            </FormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
